import { INTERNAL_ORDER_NUMBER_MAX_LENGTH } from "config/constants"
import { CopyAssetSharedKey } from "./copyAssetRows"

export interface ICopyAssetTextFieldDef {
    key: Extract<CopyAssetSharedKey,
        "internalOrderNumber" | "supplierOrderNo" | "constructionYear"
        | "referenceNumberSale" | "referenceNumberRental" | "internalNotes"
        | "monthlyRentalCostValue" | "referenceValue">
    labelKey: string
    maxLength?: number
    /** Amount fields render as number inputs with the currency after them. */
    isAmount?: boolean
}

/**
 * The plain-text shared fields, rendered identically in the "applies to all
 * copies" panel and as overridable inputs on each copy card. Labels reuse the
 * asset field keys of the add/edit flow, except where the copy dialog uses the
 * abbreviated German labels. The status dropdown and the availability date
 * picker are rendered separately; the monthly rental cost only applies to
 * borrowed copies, the reference value only to purchased ones.
 */
export const COPY_ASSET_TEXT_FIELDS: ICopyAssetTextFieldDef[] = [
    { key: "internalOrderNumber", labelKey: "asset.internalOrderNumber", maxLength: INTERNAL_ORDER_NUMBER_MAX_LENGTH },
    { key: "supplierOrderNo", labelKey: "copyAsset.fields.supplierOrderNumber" },
    { key: "constructionYear", labelKey: "asset.yearOfConstruction" },
    { key: "referenceNumberSale", labelKey: "copyAsset.fields.referenceNumberSale" },
    { key: "referenceNumberRental", labelKey: "copyAsset.fields.referenceNumberRental" },
    { key: "internalNotes", labelKey: "asset.internalNotes" },
]

export const COPY_ASSET_MONTHLY_RENTAL_FIELD: ICopyAssetTextFieldDef = {
    key: "monthlyRentalCostValue",
    labelKey: "asset.monthlyRentalCosts.label",
    isAmount: true,
}

export const COPY_ASSET_REFERENCE_VALUE_FIELD: ICopyAssetTextFieldDef = {
    key: "referenceValue",
    labelKey: "asset.referenceValue",
    isAmount: true,
}

/** The ownership-specific amount field: rental cost for borrowed copies, reference value for purchased ones. */
export function ownershipAmountField(isBorrowed: boolean): ICopyAssetTextFieldDef {
    return isBorrowed ? COPY_ASSET_MONTHLY_RENTAL_FIELD : COPY_ASSET_REFERENCE_VALUE_FIELD
}
